import { PolicyRule } from '../interfaces/policyRule';
import { ScoreModel } from '../interfaces/scoreModel';
import { ScoreModel2PolicyRule } from '../interfaces/scoreModel2PolicyRule';
import { BaseAuthenticationResource } from './BaseAuthenticationResource';

export function scoreModel2PolicyRuleFactory(scoreModel: ScoreModel, policyRule: PolicyRule) {
  return {
    scoreModelId: scoreModel.scoreModelId,
    policyRuleId: policyRule.policyRuleId,
    policyRule: policyRule,
    scoreModel: scoreModel
  };
}

export class ScoreModel2PolicyRuleResource
  extends BaseAuthenticationResource
  implements ScoreModel2PolicyRule
{
  scoreModelId = 0;
  policyRuleId = 0;
  changedBy = undefined;
  changeDate = undefined;
  policyRule = undefined;
  scoreModel = undefined;
  pk(): string | undefined {
    return `${this.scoreModelId}/${this.policyRuleId}`;
  }

  static urlRoot = '/api/ScoreModel2PolicyRules/';
}
